import * as styles from './styles.css';
export { styles as textStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { cx } from '@paypalcorp/pp-react-utils';
import { Shimmer } from '@paypalcorp/pp-react-shimmer';

var _excluded$4 = ["size", "as", "type", "className", "isLoading", "isInverse", "children"];
var HeadingText = function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  var stylesMap = {
    sm: {
      strong: styles.headingSmStrong,
      medium: styles.headingSmMedium,
      regular: styles.headingSm
    },
    lg: {
      strong: styles.headingLgStrong,
      medium: styles.headingLgMedium,
      regular: styles.headingLg
    }
  };
  var shimmerStylesMap = {
    sm: {
      strong: styles.shimmerHeadingSmStrong,
      medium: styles.shimmerHeadingSmMedium,
      regular: styles.shimmerHeadingSm
    },
    lg: {
      strong: styles.shimmerHeadingLgStrong,
      medium: styles.shimmerHeadingLgMedium,
      regular: styles.shimmerHeadingLg
    }
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: cx(shimmerStylesMap[size][type], !as && styles.overrideDefault, className),
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var styleClasses = cx(stylesMap[size][type], !as && styles.overrideDefault, className);
  var componentType = size === 'lg' ? 'h2' : 'h3';
  return /*#__PURE__*/React.createElement(as || componentType, _extends({
    className: styleClasses,
    "data-ppui-info": "heading-text_7.3.3__8.16.2"
  }, rest), children);
};

var _excluded$3 = ["as", "type", "className", "isLoading", "isInverse", "clampAtLine", "children"];
var BodyText = function (_ref) {
  var as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    clampAtLine = _ref.clampAtLine,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  var shimmerStylesMap = {
    strong: styles.shimmerBodyStrong,
    medium: styles.shimmerBodyMedium,
    regular: styles.shimmerBody
  };
  if (isLoading) {
    var shimmerStles = cx(shimmerStylesMap[type], !as && styles.overrideDefault, className);
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: shimmerStles,
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var typeStylesMap = {
    strong: styles.bodyStrong,
    medium: styles.bodyMedium,
    regular: styles.body
  };
  var styleClasses = cx(typeStylesMap[type], !as && styles.overrideDefault, clampAtLine === 1 && styles.clampAtLine1, clampAtLine === 2 && styles.clampAtLine2, clampAtLine === 3 && styles.clampAtLine3, clampAtLine === 4 && styles.clampAtLine4, className);
  return /*#__PURE__*/React.createElement(as || 'p', _extends({
    className: styleClasses,
    "data-ppui-info": "body-text_7.3.3__8.16.2"
  }, rest), children);
};

var _excluded$2 = ["as", "type", "clampAtLine", "className", "isLoading", "isInverse", "children"];
var CaptionText = function (_ref) {
  var as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    clampAtLine = _ref.clampAtLine,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var shimmerStylesMap = {
    strong: styles.shimmerCaptionStrong,
    medium: styles.shimmerCaptionMedium,
    regular: styles.shimmerCaption
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: cx(shimmerStylesMap[type], !as && styles.overrideDefault, className),
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var typeStylesMap = {
    strong: styles.captionStrong,
    medium: styles.captionMedium,
    regular: styles.caption
  };
  var styleClasses = cx(typeStylesMap[type], !as && styles.overrideDefault, clampAtLine === 1 && styles.clampAtLine1, clampAtLine === 2 && styles.clampAtLine2, clampAtLine === 3 && styles.clampAtLine3, clampAtLine === 4 && styles.clampAtLine4, className);
  return /*#__PURE__*/React.createElement(as || 'p', _extends({
    className: styleClasses,
    "data-ppui-info": "caption-text_7.3.3__8.16.2"
  }, rest), children);
};

var _excluded$1 = ["as", "type", "size", "className", "isLoading", "isInverse", "children"];
var DisplayText = function (_ref) {
  var as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var shimmerStylesMap = {
    lg: {
      strong: styles.shimmerDisplayLgStrong,
      medium: styles.shimmerDisplayLgMedium,
      regular: styles.shimmerDisplayLg
    },
    sm: {
      strong: styles.shimmerDisplaySmStrong,
      medium: styles.shimmerDisplaySmMedium,
      regular: styles.shimmerDisplaySm
    }
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: cx(shimmerStylesMap[size][type], !as && styles.overrideDefault, className),
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var sizesStyleMap = {
    lg: {
      strong: styles.displayLgStrong,
      medium: styles.displayLgMedium,
      regular: styles.displayLg
    },
    sm: {
      strong: styles.displaySmStrong,
      medium: styles.displaySmMedium,
      regular: styles.displaySm
    }
  };
  var styleClasses = cx(sizesStyleMap[size][type], !as && styles.overrideDefault, className);
  return /*#__PURE__*/React.createElement(as || 'h1', _extends({
    className: styleClasses,
    "data-ppui-info": "display-text_7.3.3__8.16.2"
  }, rest), children);
};

var _excluded = ["as", "type", "className", "isLoading", "isInverse", "children"];
var TitleText = function (_ref) {
  var as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    className = _ref.className,
    isLoading = _ref.isLoading,
    isInverse = _ref.isInverse,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var shimmerStylesMap = {
    strong: styles.shimmerTitleStrong,
    medium: styles.shimmerTitleMedium,
    regular: styles.shimmerTitle
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, _extends({
      className: cx(shimmerStylesMap[type], !as && styles.overrideDefault, className),
      hasStyleDefaults: false,
      isInverse: isInverse
    }, rest, {
      "data-ppui": "true"
    }), children);
  }
  var stylesMap = {
    strong: styles.titleStrong,
    medium: styles.titleMedium,
    regular: styles.title
  };
  var styleClasses = cx(stylesMap[type], !as && styles.overrideDefault, className);
  return /*#__PURE__*/React.createElement(as || 'h4', _extends({
    className: styleClasses,
    "data-ppui-info": "title-text_7.3.3__8.16.2"
  }, rest), children);
};

export { BodyText, CaptionText, DisplayText, HeadingText, TitleText };
